module.exports = __webpack_public_path__ + "img/3_1.07a87675.png";